import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState, CATEGORY_FEATURE_KEY } from '../../../app.state';
import { LAYOUT_FEATURE_KEY } from '@app/marketplace/storage/storage.state';
import * as fromStorage from '@app/marketplace/storage/storage.state';

export const categoriesFeature = createFeatureSelector<AppState>(CATEGORY_FEATURE_KEY);
export const selectLoading = createSelector(
  categoriesFeature,
  (state: AppState) => state.categories?.isLoading
);
export const selectResponse = createSelector(
  categoriesFeature,
  (state: AppState) => state.categories?.data
);
export const selectConfiguration = createSelector(
  categoriesFeature,
  (state: AppState) => state.categories?.data?.configuration
);
export const selectItems = createSelector(
  categoriesFeature,
  (state: AppState) => state.categories?.data?.data
);
export const selectPageSize = createSelector(
  categoriesFeature,
  (state: AppState) => state.categories?.data?.pageSize
);
export const selectPageNo = createSelector(
  categoriesFeature,
  (state: AppState) => state.categories?.data?.pageIndex
);
export const selectTotalData = createSelector(
  categoriesFeature,
  (state: AppState) => state.categories?.data?.totalCount
);
export const selectTotalPage = createSelector(
  categoriesFeature,
  (state: AppState) => state.categories?.data?.totalPages
);
export const selectCount = createSelector(
  categoriesFeature,
  (state: AppState) => state.categories?.data?.count
);
export const selectCategoryCode = createSelector(
  categoriesFeature,
  (state: AppState) => {
    if (state?.categories)
      return state.categories.categoryCode;
    else return "";
  }
);
export const selectCategoryName = createSelector(
  categoriesFeature,
  (state: AppState) => {
    if (state?.categories)
      return state.categories.categoryName;
    else return "";
  }
);
